
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingPendrivesGrid extends Serenity.EntityGrid<OrdershippingPendrivesRow, any> {
        protected getColumnsKey() { return OrdershippingPendrivesColumns.columnsKey; }
        protected getDialogType() { return OrdershippingPendrivesDialog; }
        protected getIdProperty() { return OrdershippingPendrivesRow.idProperty; }
        protected getInsertPermission() { return OrdershippingPendrivesRow.insertPermission; }
        protected getLocalTextPrefix() { return OrdershippingPendrivesRow.localTextPrefix; }
        protected getService() { return OrdershippingPendrivesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}